var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.421,
    height: 10.421,
    viewBox: "0 0 10.421 10.421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34328",
    "data-name": "Path 34328",
    d: "M12.263,12.263H4.158V4.158H7.21V3H4.158A1.158,1.158,0,0,0,3,4.158v8.105a1.158,1.158,0,0,0,1.158,1.158h8.105a1.161,1.161,0,0,0,1.158-1.158V9.21H12.263ZM9.368,3V4.158h2.078L5.756,9.849l.816.816,5.691-5.691V7.053h1.158V3Z",
    transform: "translate(-3 -3)",
    fill: "#0071cd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/LinkIcon.51511a30d42ab2d60f65a13c9db050f2.svg";
export { ForwardRef as ReactComponent };